import { dateInOriginalOffset } from "@common/dateTimeHelper";
import { DateTime } from "luxon";

export const getDates = (date: DateTime | null) => {
    const dayStart: DateTime = (date as DateTime).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
    }),
    dayEnd: DateTime = (date as DateTime).set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 999
    });
    return {
        dayStart, dayEnd
    }
}

export const isToday = (date: DateTime | null, offset: number) => {
    const today = dateInOriginalOffset(DateTime.local(), offset);
    return today.toISODate() === date?.toISODate();
}